import { render, staticRenderFns } from "./NoColumns.vue?vue&type=template&id=2869a0b7"
import script from "./NoColumns.vue?vue&type=script&lang=js"
export * from "./NoColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports